import { request } from '@/api/client';

export interface NotificationItem {
  id: string;
  type: 'system' | 'operation' | 'dingtalk' | 'feishu';
  title: string;
  description: string;
  read: boolean;
  time: string;
}

export interface AuditLogItem {
  id: string;
  action: string;
  detail: string;
  operator: string;
  time: string;
}

export function fetchNotifications(params: { type?: string; unread?: boolean } = {}): Promise<NotificationItem[]> {
  return request<NotificationItem[]>('/notifications', {
    params: { type: params.type, unread: params.unread ? 'true' : undefined },
  });
}

export function markNotificationRead(id: string): Promise<void> {
  return request<void>(`/notifications/${id}/read`, { method: 'PUT' });
}

export function markAllRead(): Promise<void> {
  return request<void>('/notifications/read-all', { method: 'PUT' });
}

export function fetchAuditLogs(): Promise<AuditLogItem[]> {
  return request<AuditLogItem[]>('/audit-logs');
}
